
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","stroke":"currentColor","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.19 20.88a8.69 8.69 0 100-17.38 8.69 8.69 0 000 17.38z","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.91 10.15a2.279 2.279 0 114.56 0c0 1.26-1.02 2.28-2.28 2.28v1.94","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 18a.81.81 0 01-.38-.08c-.12-.06-.24-.12-.34-.22-.18-.18-.28-.44-.28-.701 0-.28.1-.54.28-.721.38-.38 1.06-.36 1.42 0 .18.18.3.44.3.72 0 .261-.12.521-.3.702-.2.2-.44.3-.7.3z","fill":"currentColor"}})])
          )
        }
      }
    